/**
 * Kleiner Debounce-Hook (kein externer Dep) — extrahiert aus `ui/GlobalSearch.tsx:43-50`
 * (Phase C.2 WP-D1, Postfach-Zuordnung), damit `ui/VorgangsPicker.tsx` dieselbe Logik
 * wiederverwenden kann statt einer zweiten, unabhängigen Kopie. Verhalten unverändert.
 */
import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
